import Vue from 'vue'
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import store from '../store'

let vueEcho =  {
  install(Vue, options) {
    if (!options) {
      throw new Error("[Vue-Echo] cannot locate options");
    }

    if (typeof options !== 'object') {
      throw new Error("[Vue-Echo] cannot initiate options");
    }

    if(typeof options.socketId == 'function')
    {
      Vue.prototype.$echo = options;
    }
    else
    {
      Vue.prototype.$echo = new Echo(options);
    }

    Vue.mixin({
      mounted() {
        let channel = this.$options['channel'];
        if (typeof channel === 'function')
        {
          channel = channel.bind(this).call();
        }
        if(channel)
        {
          if(channel.startsWith('private:'))
          {
            this.channel = this.$echo.private(channel.replace('private:', ''))
          }
          else if(channel.startsWith('presence:'))
          {
            this.channel = this.$echo.join(channel.replace('presence:', ''))
          }
          else
          {
            this.channel = this.$echo.channel(channel);
          }

          let events = this.$options['echo'];

          if(events)
          {
            let self = this
            Object.keys(events).forEach(function(key){
              // Bind the VM as second parameter
              this.channel.listen(key, (payload) => {
                events[key].bind(this)(payload);
              });
            }, this);
          }
        }
      },
      beforeDestroy(){
        let channel = this.$options['channel'];
        if (typeof channel === 'function')
        {
          channel = channel.bind(this).call();
        }
        if(channel){
          if(channel.startsWith('private:'))
          {
            channel = channel.replace('private:', '');
          }
          else if(channel.startsWith('presence:'))
          {
            channel = channel.replace('presence:', '');
          }

          this.$echo.leave(channel);
        }
      }
    })
  }
}


Vue.use(vueEcho, {
  broadcaster: 'pusher',
  appId: process.env.VUE_APP_PUSHER_APP_ID || 'local',
  key: process.env.VUE_APP_PUSHER_APP_KEY || 'local',
  secret: process.env.VUE_APP_PUSHER_APP_SECRET || 'local',
  cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER || 'mt1',
  wsHost: process.env.VUE_APP_WS_HOST || 'localhost',
  wsPort: process.env.VUE_APP_WS_PORT || 6001,
  wssPort: process.env.VUE_APP_WS_PORT || 6001,
  forceTLS: false,
  encrypted: false,
  disableStats: true,
  enabledTransports: ['ws', 'wss'],
  authEndpoint: process.env.VUE_APP_API + '/broadcasting/auth',
  authorizer: function (channel, options) {
    return {
      authorize: (socketId, callback) => {
        fetch(options.authEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'Authorization': channel.name.includes('member') ? localStorage.getItem('token') : localStorage.getItem('sellerToken')
          },
          body: JSON.stringify({
            socket_id: socketId,
            channel_name: channel.name
          })
        })
        .then(res => {
          if (!res.ok) {
            throw new Error(`Received ${res.statusCode} from ${options.authEndpoint}`);
          }
          return res.json();
        })
        .then(data => {
          callback(null, data);
        })
        .catch(err => {
          callback(new Error(`Error calling auth endpoint: ${err}`), {
            auth: ""
          });
        });
      }
    };
  }
})
